import { FormGroup, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { first, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { UtilMasks } from 'src/app/utils/util-masks';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { AuditoriaService } from 'src/app/services/http/auditoria.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-auditar-laudo-auditoria',
  templateUrl: './auditar-laudo-auditoria.component.html',
  styleUrls: ['./auditar-laudo-auditoria.component.scss']
})
export class AuditarLaudoAuditoriaComponent implements OnInit {

  path: string = '';

  // Seleção campo datas
  pesquisaDataInicio: any;
  pesquisaDataFim: any;

  masks = {
    placa: {mask: UtilMasks.placa, guide: false},
    id: {mask: UtilMasks.idLaudo, guide: false},
  };

  form = new FormGroup({
    'id': new FormControl(''),
    'placa': new FormControl(''),
    'tipolaudo': new FormControl(''),
    'status': new FormControl(''),
    'cliente': new FormControl(''),
    'unidade': new FormControl(''),
    'dataRealizacaoInicio': new FormControl(''),
    'dataRealizacaoFim': new FormControl(''),
    'parecertecnico': new FormControl(''),
  });

  // Responsavel pela paginação ...
  params = {
    filter: {
      id: '',
      dataFim: new Date(),
      dataInicio: new Date(),
      parecertecnico: '',
      periodoagendamento: '',
      status: '',
      tokenlaudo: '',
      placa: '',
      chassi: '',
      fabricante: '',
      nomecliente: '',
      nomeunidade: '',
      vistoriador: '',
      nomeusuario: '',
      nometipolaudo: '',
      nomeconfig: '',
      idconfig: ''
    },
    sorting: {
      id: 'desc'
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }

  listaResultado = [];
  total: number = 0;

  listaTiposLaudos = [{ nome: 'Selecione', id: '' }];
  listaUnidadesClientes = [{ nomeFantasia: 'Selecione', id: '' }];
  listaClientes = <any> [{ nomeFantasia: 'Selecione', id: '' }];
  listaStatus = [
    {
      value:'', nome: 'Selecione'
    },
    {
      value: 0, nome: 'EM ANDAMENTO'
    },
    {
      value: 1, nome: 'FINALIZADO'
    },
    {
      value: 2, nome: 'AGENDADO'
    }
  ];

  parecerTecnico = [
    {
      id: '',
      nome: 'Selecione'
    },
    {
      id: '1',
      nome: 'APROVADO / CONFORME',
    },
    {
      id: '2',
      nome: 'APROVADO COM RESTRIÇÕES / CONFORME COM RESTRIÇÕES / COM RESTRIÇÃO',
    },
    {
      id: '3',
      nome: 'APROVADO COM APONTAMENTO / CONFORME COM APONTAMENTO / COM APONTAMENTOS',
    },
    {
      id: '4',
      nome: 'REPROVADO / NÃO CONFORME',
    },
    {
      id: '5',
      nome: 'PENDENTE',
    },
  ];


  constructor(private laudoUnionService: LaudoUnionService, private auditoriaService: AuditoriaService, private activedRoute: ActivatedRoute) {
    this.activedRoute.data.pipe(first()).subscribe(data => {
      this.path = data.tipoRelatorio;
    });
  }

  ngOnInit() {
    this.params.filter.dataInicio.setDate(1);

    // Carrega Tipos de Laudo
    this.laudoUnionService.getListaTipoLaudo().then(l => {
      this.listaTiposLaudos = this.listaTiposLaudos.concat(l);
    });

    // Carrega Unidades Clientes
    this.auditoriaService.getUnidadesClientes().then(c => {
      this.listaUnidadesClientes = this.listaUnidadesClientes.concat(c);
    });

    // Carrega lista de Clientes
    this.auditoriaService.getListaUnidadesAuditor().then(e => {
      this.listaClientes = this.listaClientes.concat(e);
    });

    this.setSituacaoLaudo("");

    // Seta a data Fim como sendo a data presente.
    let now = new Date();

    now = new Date();

    this.setDataFim({
      day: now.getDate(),
      month: now.getMonth() + 1,
      year: now.getFullYear(),
    }, false);

    this.form.valueChanges.pipe(distinctUntilChanged(), debounceTime(800)).subscribe(r => {
      this.params.filter = { ...this.params.filter, ...r };
      this.listaLaudos();
    });
    
  }

  setDataInicio(date, update = true) {
    date = this.params.filter.dataInicio.getTime();
    this.pesquisaDataInicio = date;
    if(update) this.listaLaudos();
  }

  setDataFim(date, update = true) {
    date = this.params.filter.dataFim.getTime();
    this.pesquisaDataFim = date;
    if(update) this.listaLaudos();
  }

  listaLaudos() {
    let param = {
      ...this.params,
      filter: {
        ...this.params.filter,
        dataFim: this.params.filter.dataFim.getTime(),
        dataInicio: this.params.filter.dataInicio.getTime(),
      }
    }

    // this.params.data = new Date();
    this.auditoriaService.getListalaudo(param).then(r => {
      this.total = r.total || 0;
      this.listaResultado = r.lista || [];
    });
  }

  nextPage() {
    this.listaLaudos();
  }

  // Ordena a listagem na tabela
  changeOrder() {
    this.listaLaudos();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.listaLaudos();
  }

  removeEmpty = (obj) => {
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  setSituacaoLaudo(situacaoLaudo) {
    this.params.filter.status = situacaoLaudo;
    this.listaLaudos();
  }

  downloadExcel() {
    let param = {
      ...this.params,
      filter: {
        ...this.params.filter,
        dataFim: this.params.filter.dataFim.getTime(),
        dataInicio: this.params.filter.dataInicio.getTime(),
      }
    }
    this.laudoUnionService.downloadExcelAuditoria(param).then(data => {
      let file = new FileReader();
      file.onload = () => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          const link= document.createElement('a') as HTMLAnchorElement;
                link.href = file.result as string;
                link.download = 'Laudo Excel.xlsx';
                link.addEventListener('click', () => {
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(file.result as string); 
                })
                document.body.appendChild(link);
                link.click();
        }
      }

      file.readAsDataURL(data);

    }, error => {
      console.error(error);
    });

  }

}
